<template>
  <div>
    <div class="biljeske-top-line">
        <div class="case-tabs">
            <div class="case-tab case-tab-unutarnji active">Unutarnji</div>
            <div class="case-tab case-tab-vanjski">Vanjski</div>
        </div>
        <div class="biljeske-search crm-search"><input type="text" placeholder="Pretraži faq.."><div class="top-search-button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><g><g><path fill="#fff" d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z"/></g></g></svg></div></div>
    </div>
    <div class="secondary-tabs">
        <div class="secondary-tab">Bilješke</div>
        <div class="secondary-tab active">FAQ</div>
        <div class="secondary-tab">Tagovi</div>
        <div class="secondary-tab">Templates</div>
    </div>
    <div class="faq-dropdowns">
      <div class="crm-dropdown faq-dropdown1">
          Kategorija:
           <select id="search-group">
            <option value="sve">Prikaži sve</option>
            <option value="slucajevi">Slučajevi</option>
            <option value="erp">ERP</option>
          </select>
          <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg">
        </div>
        <div class="crm-dropdown faq-dropdown2">
          Sort:
           <select id="search-group">
            <option value="sve">Najnovije</option>
            <option value="a-z">A-Z</option>
            <option value="z-a">Z-A</option>
          </select>
          <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg">
        </div>
    </div>
    <div class="faq-main-wrapper">
      <div class="faq-item">
        <div class="faq-status-category">
          <div class="faq-status faq-status-green">odgovoreno</div>
          <div class="faq-category">Kategorija: <span>slučajevi</span></div>
        </div>
        <div class="faq-question">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
        <div class="faq-answer">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur</div>
        <div class="faq-author">
          <div class="faq-author-img"></div>
          <div class="faq-author-txts">
            <div class="faq-author-name"><b>Marko M.</b></div>
            <div class="faq-author-time">prije 5 min</div>
          </div>
        </div>
      </div>
      <div class="faq-item">
        <div class="faq-status-category">
          <div class="faq-status faq-status-grey">ERP</div>
          <div class="faq-category">Kategorija: <span>slučajevi</span></div>
        </div>
        <div class="faq-question">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
        <div class="faq-answer">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur</div>
        <div class="faq-author">
          <div class="faq-author-img"></div>
          <div class="faq-author-txts">
            <div class="faq-author-name"><b>Marko M.</b></div>
            <div class="faq-author-time">prije 5 min</div>
          </div>
        </div>
      </div>
      <div class="faq-item">
        <div class="faq-status-category">
          <div class="faq-status faq-status-green">odgovoreno</div>
          <div class="faq-category">Kategorija: <span>slučajevi</span></div>
        </div>
        <div class="faq-question">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</div>
        <div class="faq-answer">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur</div>
        <div class="faq-author">
          <div class="faq-author-img"></div>
          <div class="faq-author-txts">
            <div class="faq-author-name"><b>Marko M.</b></div>
            <div class="faq-author-time">prije 5 min</div>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import auth from "@/services/auth";
import moment from "moment"
import $ from "jquery";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";


export default {
  data() {
    return {
       predmet_info:null,
      fiz_stranke:null,
      prav_protustranke:null,
      accessToken: "",
      files: [],
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      filesInSpis: [],
      nazivDokumenta: "",
      folders: [],
      //Parrent refId ima funkciju da je uvijek trenutni direktorij na vrhu (njegov id)
      newDirectoryName: "",
      parrentRefId: "",
      postaRootId: "",
      radniRootId: "",
      activityFile : null,
      ulaznaPosta: [],
      izlaznaPosta:[],
      radniDokumenti: [],
      nazivSpisFoldera: "",
      currDirectory: [],
      breadCrumbs: [],
      tmpBread: {
        id: "",
        nazivFoldera: "",
        idx: 0,
      },
    };
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
        this.getRootDocuments();
      }
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken 
    predmet_hand.getSingle(this.$route.params.uid, this.$store.state.logged_in_user.uid).then((response) => {
          console.log(response)

          this.predmet_info = response.data.all_info_predmet.predmet_info[0]
          this.fiz_stranke = response.data.all_info_predmet.fiz_stranke
          this.prav_protustranke = response.data.all_info_predmet.prav_protustranke



        });
  },
  methods: {
    goToPredmet(nastavak)
    {
      this.$router.push(nastavak)

    },
    switchDate(inData) {
      return moment(inData.toString()).format("lll");
    },
    switchDateRow(inData) {
      return moment(inData.toString()).format("L");
    },
    goStepBack() {
      this.folders = [];
      this.filesInSpis = [];
      this.parrentRefId = this.parrentRefId.pop();
      this.goDown(this.parrentRefId[parrentRefId.length - 1]);
    },

    openFile(linkToFile) {
      window.open(linkToFile);
    },
    deleteFile(fileId) {
      var path = "/drive/items/" + fileId;
      share
        .deleteFile(this.accessToken, this.$route.params.uid, path)
        .then(() => {
          this.goDown(this.selectedFolder);
        });
    },
    // createNewFolder() {
    //   share.newFolder(
    //     this.accessToken,
    //     this.$route.params.uid,
    //     this.nazivFoldera
    //   );
    // },
     setFileForActivity(fileRef) {
      this.activityFile = fileRef;
      console.log(this.activityFile);
    },
    toPDF(file) {
      var path = "/drive/items/" + file.id;
      console.log(path);
      console.log(this.breadCrumbs[this.breadCrumbs.length - 1].id);

      share
        .convertToPDF(
          this.accessToken,
          this.$route.params.uid,
          this.breadCrumbs[this.breadCrumbs.length - 1].id,
          path
        )
        .then((response) => {
          console.log(response.data["@microsoft.graph.downloadUrl"]);
        });
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0];
      this.selectedFile = selectedFile;
      console.log(this.selectedFile);
    },
    // createNewDocument() {
    //   this.selectedFile = new Document({
    //     name: "Somefile.docx",
    //   });

    //   var formData = new FormData();
    //   formData.append("file", this.selectedFile);
    //   formData.append("token", this.accessToken);
    //   formData.append("groupId", this.$route.params.uid);
    //   formData.append("sid", this.selectedFolder);
    //   formData.append("name", this.nazivDokumenta);
    //   console.log(this.nazivDokumenta);
    //   // appending file

    //   share.addDocumentInSpis(formData).then(() => {
    //     this.goDown(this.selectedFolder);
    //     this.nazivDokumenta = "";
    //   });
    // },

    previewFiles() {
      var input = document.getElementById("myFiles");
      var file = input.files[0];
      console.log(file);
      share.addDocumentInSpis(
        this.accessToken,
        this.$route.params.uid,
        this.selectedFolder,
        file
      );
    },
    async addNewUploadFile() {
      const formData = new FormData();
      console.log(this.selectedFile);
      formData.append("file", this.selectedFile);
      formData.append("token", this.accessToken);
      formData.append("groupId", this.$route.params.uid);
      formData.append("sid", this.breadCrumbs[this.breadCrumbs.length - 1].id);
      formData.append("name", this.selectedFile.name);
      // appending file

      share.addDocumentInSpis(formData);
      setTimeout(() => {
        this.currDirectory = this.getAllDocsById(
          this.breadCrumbs[this.breadCrumbs.length - 1].id
        );
      }, 200);
    },
    createNewFolder() {
      this.createFoldToParrent(
        this.breadCrumbs[this.breadCrumbs.length - 1].id,
        this.newDirectoryName
      );
    },
    createFoldToParrent(parrentId, docname) {
      share.createFolderDocs(
        this.accessToken,
        this.$route.params.uid,
        parrentId,
        docname
      );
      // .then(() => {
      //   this.goDown(this.selectedFolder);
      //   this.nazivDokumenta = "";
      // });
    },
    breadcrumbsViewPushback(indexCut) {
      if (this.breadCrumbs.length > 1) {
        this.breadCrumbs = this.breadCrumbs.slice(0, indexCut + 1);
        this.currDirectory = this.getAllDocsById(
          this.breadCrumbs[this.breadCrumbs.length - 1].id
        );
      }
    },
    setNewFileView(foldRef) {
      //primi id foldera čiju ćemo djecu pregledati
      //Nakon toga napravi poziv i osvježi koje su datoteke unutra
      var duljina = this.breadCrumbs.length;
      this.breadCrumbs.push({
        id: foldRef.id,
        nazivFoldera: foldRef.name,
        idx: duljina,
      });
      this.currDirectory = this.getAllDocsById(foldRef.id);
    },
    setInitFileView(foldRef) {
      //primi id foldera čiju ćemo djecu pregledati
      //Nakon toga napravi poziv i osvježi koje su datoteke unutra
      this.breadCrumbs = [];
      var duljina = this.breadCrumbs.length;
      this.breadCrumbs.push({
        id: foldRef.id,
        nazivFoldera: foldRef.name,
        idx: duljina,
      });
      this.currDirectory = this.getAllDocsById(foldRef.id);
    },
    createNewSpis() {
      this.createFoldToParrent(this.postaRootId, this.nazivSpisFoldera);
    },
    getAllDocsById(sid) {
      var ret_fold = [];
      var ret_files = [];
      share
        .getDocumentsInSpis(this.accessToken, this.$route.params.uid, sid)
        .then((response) => {
          response.data.value.forEach((dat) => {
            if (dat.folder != undefined) {
              ret_fold.push(dat);
            }else{
              ret_files.push(dat);
            }
          });
        });
        console.log(ret_fold);
        console.log(ret_files);
      return ret_fold;
    },
    getfoldersById(sid) {
      var ret_fold = [];
      share
        .getDocumentsInSpis(this.accessToken, this.$route.params.uid, sid)
        .then((response) => {
          response.data.value.forEach((dat) => {
              ret_fold.push(dat);
          });
        });
      return ret_fold;
    },
    getRootDocuments() {
      console.log(this.$route.params.uid);
      console.log(this.accessToken);
      share
        .getRootDocs(this.accessToken, this.$route.params.uid)
        .then((response) => {
          response.data.files.value.forEach((doc) => {
            if (doc.name == "Izlazna pošta") {
              this.postaRootId = doc.id;
              this.izlaznaPosta = this.getfoldersById(this.postaRootId);
              console.log(this.izlaznaPosta);             
            }else if(doc.name == "Ulazna pošta") {
              this.postaRootId = doc.id;
              this.ulaznaPosta = this.getfoldersById(this.postaRootId);
              console.log(this.ulaznaPosta);             
            }
          });
        });
    },
  },
  mounted() {},
};
</script>

<style>
</style>